import update from 'immutability-helper';
import mapValues from 'lodash/mapValues';
import * as AuthActionTypes from '../../auth/actions';

// Creates a reducer managing filtering, given the action types to handle,
// and a function telling how to extract the key from an action.
const filter = ({ types, mapActionToKey }) => {
	if (!Array.isArray(types) || types.length !== 3) {
		throw new Error('Expected types to be an array of three elements.');
	}
	if (!types.every(t => typeof t === 'string')) {
		throw new Error('Expected types to be strings.');
	}
	if (typeof mapActionToKey !== 'function') {
		throw new Error('Expected mapActionToKey to be a function.');
	}

	const [requestType, successType, failureType] = types;

	const initialState = {
		loading: false,
		ids: []
	};

	const updateFiltering = (state = initialState, action) => {
		switch (action.type) {
			case requestType:
				return update(state, {
					loading: { $set: true }
				});
			case successType:
				return update(state, {
					loading: { $set: false },
					ids: { $set: action.response.result }
				});
			case failureType:
				return update(state, {
					loading: { $set: false }
				});
			default:
				return state;
		}
	};

	return (state = {}, action) => {
		// Update filtered data by key
		switch (action.type) {
			case requestType:
			case successType:
			case failureType:
				const key = mapActionToKey(action);
				if (typeof key !== 'string') {
					throw new Error('Expected key to be a string.');
				}
				return update(state, {
					[key]: { $set: updateFiltering(state[key], action) }
				});
			case AuthActionTypes.LOGOUT:
				// reset all keys
				return {};
			default:
				return state;
		}
	};
};

export default filter;